import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { MDBContainer, MDBRow, MDBCol, MDBBtn } from "mdb-react-ui-kit";
import axios from "axios";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Skeleton from "@mui/material/Skeleton";
import "./landing.css";
// components
import MetaTagsBusinessOwners from "../../components/meta-tags-seo/MetaTagsBusinessOwners";
import LandingHeader from "../../components/landing-page/landing-header/LandingHeader";
import LandingCard from "../../components/landing-page/landing-card/LandingCard";
import Footer from "../../components/landing-page/footer/Footer";
// imgs
import img1 from "../../images/landing/sign in.png";
import img2 from "../../images/landing/dashboard.png";
import img3 from "../../images/landing/Search.png";
import img4 from "../../images/landing/comment.png";
import img5 from "../../images/landing/immigrate.png";
import img6 from "../../images/landing/relationship.png";
import banner_img from "../../images/landing/costumer.png";
import img_header from "../../images/landing/picture header.png";
// config
import configData from "../../config/config.json";

function Landing() {
  // footer page
  const [footerData, setFooterData] = useState({});
  const [headerData, setheaderData] = useState({
    HeaderLogo: {
      Title: "",
      Link: "",
    },
  });

  const [ApiDataCome, setApiDataCome] = useState({
    blog: false,
    footer: false,
  });

  const [Blog, setBlog] = useState([
    // { filePath: "", pageUrl: "", titr: "" },
  ]);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  useEffect(() => {
    //api header
    const header = {
      ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
      LangId: 1,
      Page: "index",
    };
    //1 meta tag
    axios
      .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
        headers: header,
      })
      .then((response) => {
        if (response.data.isSuccess) {
          setMTagsCome(true);
          setMetaData(response.data.data);
        }
      })
      .catch((error) => {
        // alert(error);
      });
    // 2 blog
    axios
      .get(
        configData.BLOG_API_DOMAIN +
          "/wp-json/wp/v2/posts?_embed&tags=1776&per_page=3"
      )
      .then((response) => {
        setBlog(response.data);
        setApiDataCome((ApiDataCome) => ({ ...ApiDataCome, blog: true }));
      })
      .catch((error) => {
        // alert(error);
      });
    // 3 footer
    axios
      .get(configData.API_DOMAIN + "/api/v1/Footers", {
        headers: header,
      })
      .then((response) => {
        setFooterData(response.data.data);
        setApiDataCome((ApiDataCome) => ({ ...ApiDataCome, footer: true }));
      })
      .catch((error) => {
        // alert(error);
      });
  }, []);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      <LandingHeader />
      <MDBContainer>
        <MDBRow className="justify-content-center mx-0">
          <h2 className="landing-tit">
            چرا کسب‌وکار خود را
            <br className="d-md-none" />
            در گیشنیز ثبت کنیم؟
          </h2>
          <MDBCol md="6" className="landing-card-pr">
            <LandingCard
              img={img5}
              text={[
                "تنها در آمریکا و کانادا بیش از ",
                <strong>۳ میلیون مهاجر فارسی‌زبان</strong>,
                " زندگی می‌کنند.",
              ]}
            />
          </MDBCol>
          <MDBCol md="6" className="landing-card-pl">
            <LandingCard
              img={img1}
              text={["ثبت نام در گیشنیز ", <strong>رایگان</strong>, " است."]}
            />
          </MDBCol>
          <MDBCol md="6" className="landing-card-pr">
            <LandingCard
              img={img4}
              text={[
                "تا کنون ",
                <strong>۲۳۸۵ کسب‌وکار</strong>,
                " در گیشنیز ثبت شده‌اند.",
              ]}
              desc={[
                "200 وکــیل، ۹۰۰ مشاور امـلاک، ۴۰۰ پزشک",
                <br />,
                "300 رستوران و صدها مورد دیگر در بخش‌های مختلف.",
              ]}
            />
          </MDBCol>
          <MDBCol md="6" className="landing-card-pl">
            <LandingCard
              img={img3}
              text={[
                "کسب‌وکارهای فارسی‌زبان تاکنون در ",
                <strong>۷ استان کانادا و ۷ ایالت آمریکا</strong>,
                " ثبت شده‌اند.",
              ]}
              desc={[
                "انتاریو، کبک، بریتیش کلمبیا، آلبرتا و ...",
                <br />,
                "کالیفرنیا، واشنگتن، اوهایو، نیوجرسی و ...",
              ]}
            />
          </MDBCol>
          <MDBCol md="6" className="landing-card-pr">
            <LandingCard
              img={img2}
              text={[
                "استفاده از ابزارهایی که به بیشتر ",
                <strong>دیده شدن کسب‌وکار</strong>,
                " شما کمک می‌کند.",
              ]}
            />
          </MDBCol>
          <MDBCol md="6" className="landing-card-pl">
            <LandingCard
              img={img6}
              text={[
                "برقراری ارتباطی تازه با مشتریان قدیمی و جدید و استفاده از ",
                <strong>نظرات</strong>,
                " آن‌ها.",
              ]}
            />
          </MDBCol>
          <MDBCol>
            <div className="landing-banner">
              <div className="landing-banner-box d-none d-md-block">
                <h6 className="landing-banner-box-tit">به گیشنیز بپیوندید!</h6>
                <Link
                  to={
                    !getCookie("OwnerId")
                      ? "/signup"
                      : getCookie("OwnerBizNumber") != 0
                      ? "/business-dashboard"
                      : "/register-business-step1"
                  }
                  className="landing-banner-box-btn"
                >
                  ثبت نام
                </Link>
              </div>
              <img
                src={banner_img}
                alt="banner"
                className="landing-banner-img"
              />
              <div className="landing-banner-box d-md-none">
                <div className="centerr">
                  <h6 className="landing-banner-box-tit">
                    به گیشنیز بپیوندید!
                  </h6>
                  <Link
                    to={
                      !getCookie("OwnerId")
                        ? "/signup"
                        : getCookie("OwnerBizNumber") != 0
                        ? "/business-dashboard"
                        : "/register-business-step1"
                    }
                    className="landing-banner-box-btn"
                  >
                    ثبت نام
                  </Link>
                </div>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <div className="landing-blog-box">
        <h3 className="landing-blog-tit">گیشنیز برای کسب‌وکارها</h3>
        <div className="d-none d-md-flex justify-content-center">
          {ApiDataCome.blog ? (
            Blog.map((item) => (
              <a
                href={item.link}
                target="__blank"
                className="mx-2"
                key={item.id}
              >
                <LazyLoadImage
                  // PlaceholderSrc={
                  //   "https://cdn.gishniz.com/business/1/1820/Cover_202281510232610557514.png"
                  // }
                  src={
                    item._embedded["wp:featuredmedia"]["0"].media_details.sizes
                      .medium_large.source_url
                  }
                  alt={item.title.rendered}
                  className="landing-blog-img"
                />
              </a>
            ))
          ) : (
            <>
              <Skeleton
                className="mx-2 landing-blog-img"
                variant="rectangular"
                height={235}
                width={352}
                animation="wave"
              />
              <Skeleton
                className="mx-2 landing-blog-img"
                variant="rectangular"
                height={235}
                width={352}
                animation="wave"
              />
              <Skeleton
                className="mx-2 landing-blog-img"
                variant="rectangular"
                height={235}
                width={352}
                animation="wave"
              />
            </>
          )}
        </div>
        <div className="category-items pt-md-3  pt-xs-40 d-md-none">
          {ApiDataCome.blog ? (
            Blog.map((item) => (
              <div key={item.id} className="cat-item cat-item-child-scro">
                <a href={item.link} target="__blank" className="mx-2">
                  <LazyLoadImage
                    // PlaceholderSrc={
                    //   "https://cdn.gishniz.com/business/1/1820/Cover_202281510232610557514.png"
                    // }
                    src={
                      item._embedded["wp:featuredmedia"]["0"].media_details
                        .sizes.medium_large.source_url
                    }
                    alt={item.title.rendered}
                    className="landing-blog-img"
                  />
                </a>
              </div>
            ))
          ) : (
            <>
              <div className="cat-item cat-item-child-scro">
                <Skeleton
                  className="mx-2 landing-blog-img "
                  variant="rectangular"
                  height={163}
                  width={232}
                  animation="wave"
                />
              </div>
              <div className="cat-item cat-item-child-scro">
                <Skeleton
                  className="mx-2 landing-blog-img "
                  variant="rectangular"
                  height={163}
                  width={232}
                  animation="wave"
                />
              </div>
              <div className="cat-item cat-item-child-scro">
                <Skeleton
                  className="mx-2 landing-blog-img "
                  variant="rectangular"
                  height={163}
                  width={232}
                  animation="wave"
                />
              </div>
            </>
          )}
        </div>
      </div>
      <Footer data={footerData} dataCome={ApiDataCome.footer} />
    </>
  );
}

export default Landing;
